export const isSHA256TokenWellFormed = (token: unknown): token is string => typeof token === 'string' && /^[A-Za-z0-9_-]{43}=$/.test(token)
